import React, { useEffect, useState, useRef } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import jwt_decode from 'jwt-decode';
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';
import axios from 'axios';

const ResponsiveCSS = () => (
  <style>{`
    @media (max-width: 480px) {
      .pd-card-header { flex-direction: column; align-items: flex-start !important; gap: 8px; padding: 12px !important; }
      .pd-card-header select { font-size: 12px !important; padding: 4px 6px !important; }
      .pd-summary-row { gap: 6px !important; margin-bottom: 10px !important; }
      .pd-summary-col { flex: 1 0 0 !important; max-width: none !important; padding: 0 !important; }
      .pd-summary-box { padding: 8px 6px !important; }
      .pd-summary-box .fs-4 { font-size: 15px !important; }
      .pd-summary-box .small { font-size: 10px !important; }
      .pd-card-body { padding: 10px !important; }
      table.pd-table { font-size: 12px !important; }
      table.pd-table td, table.pd-table th { padding: 6px 8px !important; }
      .btn-sm { padding: 3px 8px !important; font-size: 11px !important; }
    }
  `}</style>
);

const List = () => {
  const token = localStorage.getItem('jwtToken');
  let decodedToken = null;
  try {
    decodedToken = token ? jwt_decode(token) : null;
  } catch (err) {
    console.error('Invalid token:', err);
  }
  const user_id = decodedToken ? decodedToken.user_id : null;
  const [statusFilter, setStatusFilter] = useState("paid");

  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const currentPage = useRef();

  useEffect(() => {
    currentPage.current = 1;
    getPaginatedUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter, limit]);

  const handleApprovePayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_update`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error approving payment:', error);
      alert('Error approving payment: ' + error.message);
    }
  };

  const handleRejectPayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_reject`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error rejecting payment:', error);
      alert('Error rejecting payment: ' + error.message);
    }
  };

  function handlePageClick(e) {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  }

  async function getPaginatedUsers() {
    try {
      const response = await axios.get(
        `${apiConfig.baseURL}/api/agent/pending_balance_request`, {
          params: {
            page: currentPage.current,
            limit: limit,
            user_id: user_id,
            status: statusFilter === 'all' ? undefined : statusFilter,
          },
        }
      );
      const sortedData = response.data.result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setData(sortedData);
      setPageCount(response.data.pageCount);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  }

  const MyPaginate = styled(ReactPaginate).attrs({
    activeClassName: "active",
  })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;

    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.previous a,
    li.next a,
    li.break a {
      border-color: transparent;
    }
    li.active a {
      background-color: #0366d6;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
      background-color: #15073A !important;
    }
    li.disable,
    li.disabled a {
      cursor: default;
      background-color: #15073A !important;
    }
  `;

  const formatTimestamp = (timestamp) => {
    let date = timestamp ? new Date(timestamp) : new Date();

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    }).toLowerCase();

    if (date.toDateString() === today.toDateString()) {
      return formattedTime;
    } else if (date.toDateString() === yesterday.toDateString()) {
      return `${formattedTime} Yesterday`;
    } else {
      const diffInDays = Math.floor((today - date) / (1000 * 60 * 60 * 24));
      if (diffInDays === 1) {
        return `${formattedTime} Yesterday`;
      } else if (diffInDays <= 7) {
        return `${formattedTime} ${diffInDays} days ago`;
      } else {
        const formattedDate = date.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
        }).replace(/\//g, '.');
        return `${formattedTime} ${formattedDate}`;
      }
    }
  };

  const summary = data.reduce(
    (acc, d) => {
      acc.count += 1;
      acc.totalAmount += Number(d.send_amount) || 0;
      acc.totalBonus += (Number(d.send_amount_in_bdt) || 0) - (Number(d.send_amount) || 0);
      return acc;
    },
    { count: 0, totalAmount: 0, totalBonus: 0 }
  );

  return (
    <>
      <ResponsiveCSS />
      <div id="main-wrapper">
        <Navbar />
        <Chatbox />
        <HeaderRight />
        <LeftSidebar />
        <div className="content-body">
          <div className="container-fluid">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header pd-card-header" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
                  <h4 className="card-title" style={{ margin: 0 }}>Pending Deposits</h4>
                  <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                    <option value="">Sort</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="">Select Sorting</option>
                    <option value="pending">Pending</option>
                    <option value="paid">Paid</option>
                    <option value="reject">Reject</option>
                  </select>
                </div>

                <div className="card-body pd-card-body">
                  <div className="row mb-3 pd-summary-row">
                    <div className="col-md-4 pd-summary-col">
                      <div className="p-3 border rounded text-center pd-summary-box">
                        <div className="text-muted small">Total Records</div>
                        <div className="fs-4 fw-bold">{summary.count}</div>
                      </div>
                    </div>
                    <div className="col-md-4 pd-summary-col">
                      <div className="p-3 border rounded text-center pd-summary-box">
                        <div className="text-muted small">Total Amount</div>
                        <div className="fs-4 fw-bold">{summary.totalAmount.toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="col-md-4 pd-summary-col">
                      <div className="p-3 border rounded text-center pd-summary-box">
                        <div className="text-muted small">Total Bonus</div>
                        <div className="fs-4 fw-bold">{summary.totalBonus.toFixed(2)}</div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table pd-table">
                      <thead>
                        <tr>
                          <th className="text-nowrap">user ID</th>
                          <th className="text-nowrap">Transaction ID</th>
                          <th className="text-nowrap">Date</th>
                          <th className="text-nowrap">Method type</th>
                          <th className="text-nowrap">Amount</th>
                          <th className="text-nowrap">Bonus Amount</th>
                          <th className="text-nowrap">From</th>
                          <th className="text-nowrap">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((deposit, index) => (
                          <tr key={deposit._id || index}>
                            <td className="text-nowrap">{deposit.user_id}</td>
                            <td className="text-nowrap">{deposit.trxid}</td>
                            <td className="text-nowrap">{formatTimestamp(deposit.createdAt)}</td>
                            <td className="text-nowrap">{deposit.selected_method}</td>
                            <td className="text-nowrap">{deposit.send_amount}</td>
                            <td className="text-nowrap">{deposit.send_amount_in_bdt - deposit.send_amount}</td>
                            <td className="text-nowrap">{deposit.sender_number}</td>
                            <td>
                              {deposit.status === 'paid' ? (
                                <button className="btn btn-sm btn-success">Paid</button>
                              ) : deposit.status === 'reject' ? (
                                <button className="btn btn-sm btn-danger">Rejected</button>
                              ) : (
                                <>
                                  <a
                                    href="#"
                                    className="btn btn-success shadow btn-xs sharp me-1"
                                    onClick={(event) => handleApprovePayment(deposit._id, event)}
                                  >
                                    <i className="fa fa-check"></i>
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-danger shadow btn-xs sharp me-1"
                                    onClick={(event) => handleRejectPayment(deposit._id, event)}
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <MyPaginate
                      breakLabel="..."
                      nextLabel=">"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="<"
                      renderOnZeroPageCount={null}
                      marginPagesDisplayed={2}
                      containerClassName="pagination justify-content-center"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage.current - 1}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default List;